export default __webpack_public_path__ + "static/media/Group8879.057e531d.svg";